module.exports = __webpack_public_path__ + "static/media/01_video_thumbnail_tablet.487209b6.jpg";